import { render, staticRenderFns } from "./HotItem.vue?vue&type=template&id=a38732e4&scoped=true"
import script from "./HotItem.vue?vue&type=script&lang=js"
export * from "./HotItem.vue?vue&type=script&lang=js"
import style0 from "./HotItem.vue?vue&type=style&index=0&id=a38732e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38732e4",
  null
  
)

export default component.exports